import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Page from '../../../components/Page/Page';
import { HomeProvider } from '../../context/homeContext';
import getAllHomePageSettings from './getAllHomePageSettings.graphql'
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import s from './PartnerPrivacyPolicy.css';

class PartnerPrivacyPolicy extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data: { getEditStaticPage, loading: staticLoading } } = this.props;
    const { currentLocale } = this.props;
    let homeSettings = {}, dynamicStaticContentSettings, content;
    if (!loading) {
      getAllHomePageSettings?.homePageData?.map((item) => {
        homeSettings[item.name] = item.value
      })
    }

    dynamicStaticContentSettings = getDynamicTitleByLocale({ dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContentSettings, locale: currentLocale });

    content = dynamicStaticContentSettings[0]?.content || getEditStaticPage?.result?.content;

    const pageBanner = getEditStaticPage?.result?.pageBanner;

    return (
      <div>
        {!loading && !staticLoading &&
          <div>
            <HomeProvider value={homeSettings}>
              <div className={s.homeBanner} />
              <Page
                html={content}
                pageBanner={pageBanner}
              />
            </HomeProvider>
          </div>}
      </div>
    );
  }
}

const mapState = (state) => ({
  currentLocale: state?.intl?.locale
});

const mapDispatch = {
};

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  })
)(PartnerPrivacyPolicy);
